import { createAsyncThunk } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/gatsby';
import { getApiError } from '../../utils';
import Axios from '../../utils/Axios';

interface SubmitContactFormProps {
  id: string;
  note: string;
  requested_response: string;
}

export const submitContactForm = createAsyncThunk(
  'contactus/submitContactForm',
  async (props: SubmitContactFormProps, { rejectWithValue }) => {
    const requestData = {
      note: props.note,
      requested_response: props.requested_response,
    };
    try {
      const response = await Axios.post(
        `/contacts/loan-officer/${props.id}/contact-request/`,
        {
          ...requestData,
        },
      );
      return response.data;
    } catch (error: unknown) {
      Sentry.captureException(error);

      const normalizedError = getApiError(error);
      return rejectWithValue(normalizedError);
    }
  },
);
